import { useTranslation } from 'react-i18next';
import EquipmentInvoiceLineForm from '../form/EquipmentInvoiceLineForm';
import { EnhancedDialog } from 'components/enhanced';

interface EquipmentInvoicAddLinesDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (data: any) => void;
  contractId: number;
}

export const EquipmentInvoicAddLinesDialog = ({
  isOpen,
  onClose,
  onSubmit,
  contractId
}: EquipmentInvoicAddLinesDialogProps) => {
  const { t } = useTranslation();

  return (
    <EnhancedDialog
      open={isOpen}
      onClose={onClose}
      title={'Aggiungi Voce di Fattura'}
      subTitle={'Seleziona e configura i dettagli della riga da includere nella fattura'}
      submitLabel={t('actions.save', 'Salva')}
      cancelLabel={t('actions.reset', 'Annulla')}
      maxWidth="md"
      submitButtonProps={{
        type: 'submit',
        form: 'newInvoice'
      }}>
      <EquipmentInvoiceLineForm onSubmit={onSubmit} contractId={contractId} />
    </EnhancedDialog>
  );
};

export default EquipmentInvoicAddLinesDialog;
